module.exports = "<div class=\"row\">\n  <div *ngFor=\"let variant of variants\" class=\"col-sm-8\">\n    <app-variant [variant]=\"variant\">\n      <app-buy-buttons [variant]=\"variant\"></app-buy-buttons>\n    </app-variant>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/variant-list/variant-list.component.html
// module id = 752
// module chunks = 1